import {createAction} from '@reduxjs/toolkit';
import {System} from 'common/models/system';

import {namespace} from '../constants';
import {ReducerCallback} from '../system.types';

export const setThemeAction = createAction<System['theme']>(`${namespace}/setTheme`);

const setTheme: ReducerCallback<System['theme']> = (state, action) => {
    const {payload: theme} = action;
    state.theme = theme;
};

export default setTheme;
